import CancerPage from "../components/CancerPage";

const stepsText = [
  "Biopsy: This is the most critical step for a definitive diagnosis.",
  "Endoscopic Ultrasound (EUS) with Fine-Needle Aspiration (FNA): A thin, flexible tube equipped with an ultrasound probe is passed through the mouth into the stomach to visualize the pancreas, and a fine needle is used to take tissue samples.",
  "CT-guided needle biopsy: A needle is inserted through the skin into the pancreas with CT guidance.",
  "Blood Tests: Blood tests are used to assess the patient's overall health and to check for specific tumor markers, such as CA 19-9, which can be elevated in pancreatic cancer.",
];

export default function PancreaticCancerPage() {
  return (
    <CancerPage
      cancerName="Pancreatic Cancer"
      scanType="CT-Scan / MRI Scan"
      analysisText="A CT scan of the abdomen has identified a mass in the pancreas. This finding is highly concerning for pancreatic cancer, specifically an adenocarcinoma, which is the most common type of pancreatic cancer and arises from the cells that line the ducts of the pancreas. The CT scan is a critical tool for visualizing the pancreas. A specialized 'pancreatic protocol' CT scan involves taking images at different times after contrast dye injection, which is particularly useful for highlighting the tumor and assessing its relationship with surrounding blood vessels."
      stepsTitle="Necessary Steps for Diagnosis:"
      stepsText={stepsText}
    />
  );
}
